import GendonganMshapeNewborn from "@/components/Compare/GendonganMshapeNewborn";
import { NextPage } from "next";
import { NextSeo } from "next-seo";


const GendonganMshapeNewbornPage: NextPage = () => {

  return (
    <div style={{ backgroundColor: '#F2F0ED' }}>
      <NextSeo
        title="Gendongan SSC M Shape Terbaik untuk Newborn - Perbandingan Lengkap"
        description="Sedang cari gendongan SSC M Shape terbaik untuk newborn? Simak perbandingan berbagai pilihan gendongan yang aman, nyaman, dan ideal dipakai seharian. Temukan yang paling cocok untuk Mom!"
        canonical={process.env.NEXT_PUBLIC_HOSTNAME + "/compare/gendongan-mshape-newborn"}
        openGraph={{
          images: [{
            url: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-m01.webp",
            width: 1147,
            height: 836,
            alt: 'Mengenal Posisi M Shape pada Gendongan SSC',
          }]
        }}
      />
      <GendonganMshapeNewborn />
    </div>
  )
}

export default GendonganMshapeNewbornPage
